let activeEnv = process.env.GATSBY_ACTIVE_ENV || 'development'
module.exports = {
  siteMetadata: {
    title: 'SRE NEXT 2020',
    description:
      'SRE NEXTとは、SREによるSREのためのコミュニティベースのカンファレンスです。',
    siteUrl: 'https://sre-next.dev',
    author: 'SRE NEXT team',
    twitter: '@srenext',
    adsense: '',
  },
  pathPrefix: '/2020',
  plugins: [
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        name: 'SRE NEXT 2020',
        short_name: 'SRE NEXT 2020',
        description:
          'SRE NEXTとは、SREによるSREのためのコミュニティベースのカンファレンスです。',
        homepage_url: 'https://sre-next.dev',
        start_url: '',
        background_color: '#fff',
        theme_color: '#3290e6',
        display: 'standalone',
        icons: [
          {
            src: '/img/android-chrome-192x192.png',
            sizes: '192x192',
            type: 'image/png',
          },
          {
            src: '/img/android-chrome-512x512.png',
            sizes: '512x512',
            type: 'image/png',
          },
        ],
      },
    },
    {
      resolve: 'gatsby-plugin-google-analytics',
      options: {
        trackingId: '',
      },
    },
    {
      resolve: 'gatsby-plugin-s3',
      options: {
        bucketName:
          activeEnv === 'production' ? 'sre-next.dev' : 'sre-next-preview',
        bucketPrefix: '2020',
        acl: null,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        path: './src/data/',
      },
    },
    'gatsby-plugin-catch-links',
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-remove-serviceworker',
    'gatsby-plugin-sass',
    'gatsby-plugin-sharp',
    'gatsby-plugin-sitemap',
    'gatsby-transformer-json',
    'gatsby-transformer-sharp',
  ],
}
